export const SEGMENTS_DATA = {
  "Roupas / Moda": {
    id: "fashion",
    label: "Roupas & Moda",
    icon: "StoreMallDirectory",
    badgeColor: "#ec4899",
    badgeBg: "#fdf2f8",
    tag: "Moda & Vestuário",
    headline: "Cadastros essenciais e vitrine online",
    steps: [
      {
        id: "categories",
        title: "Criar Categorias",
        description: "Separe suas peças por tipo (Camisetas, Calças, Vestidos).",
        route: "/home/categoria/nova",
        actionText: "Criar Categoria",
        type: "link"
      },
      {
        id: "products",
        title: "Cadastrar Estoque",
        description: "Cadastre produtos com fotos, preços e estoque inicial.",
        route: "/home/produto/novo",
        actionText: "Cadastrar Produto",
        type: "link"
      },
      {
        id: "duxia_product_description",
        title: "Descrição com duxIA",
        description: "Gere descrições persuasivas para seus looks na tela de produtos.",
        route: "/home/produto/pesquisar",
        actionText: "Gerar Descrição",
        type: "duxia_feature"
      },
      {
        id: "catalog",
        title: "Ativar Catálogo Virtual",
        description: "Monte sua vitrine para receber pedidos no WhatsApp.",
        route: "/home/gestao/catalogo",
        actionText: "Ajustar Catálogo",
        type: "link",
        requireAddon: "catalog"
      },
      {
        id: "duxia_brand_palette",
        title: "Paleta de Cores duxIA",
        description: "Deixe a duxIA sugerir as cores ideais para a sua vitrine virtual.",
        route: "/home/gestao/catalogo",
        actionText: "Sugerir Paleta",
        type: "duxia_feature",
        requireAddon: "catalog"
      },
      {
        id: "first_sale",
        title: "Primeira Venda no PDV",
        description: "Simule uma venda rápida no caixa.",
        route: "/home/vendas/nova",
        actionText: "Abrir PDV",
        type: "link"
      },
      {
        id: "duxia_eval",
        title: "Diagnóstico com a DuxIA",
        description: "Avalie o potencial de vendas do estoque cadastrado.",
        prompt: "Avalie meu estoque recém-cadastrado por categorias e produtos: quais itens têm maior potencial de venda no catálogo e quais categorias ainda posso expandir?",
        actionText: "Consultar DuxIA",
        type: "duxia"
      }
    ]
  },
  "Restaurante / Alimentação": {
    id: "drinks_food",
    label: "Adega & Restaurante",
    icon: "LocalBar",
    badgeColor: "#8b5cf6",
    badgeBg: "#f5f3ff",
    tag: "Bebidas & Gastronomia",
    headline: "Bebidas, combos, garçons e comandas",
    steps: [
      {
        id: "stock_drinks",
        title: "Cadastrar Bebidas",
        description: "Cadastre garrafas, latas, destilados e gelo.",
        route: "/home/produto/novo",
        actionText: "Cadastrar Bebidas",
        type: "link"
      },
      {
        id: "services_combos",
        title: "Criar Insumos & Combos",
        description: "Monte copões, drinks, doses e combos.",
        route: "/home/servico/novo",
        actionText: "Criar Combo",
        type: "link"
      },
      {
        id: "duxia_product_description",
        title: "Descrição com duxIA",
        description: "Crie textos irresistíveis para drinks e combos na tela de produtos.",
        route: "/home/produto/pesquisar",
        actionText: "Gerar Descrição",
        type: "duxia_feature"
      },
      {
        id: "waiter_user",
        title: "Cadastrar Garçom / Atendente",
        description: "Crie logins para atendimento e lançamento de pedidos.",
        route: "/home/usuarios/novo",
        actionText: "Novo Usuário",
        type: "link"
      },
      {
        id: "delivery_settings",
        title: "Taxas de Entrega",
        description: "Cadastre as taxas de entrega como serviços de repasse (motoboy).",
        route: "/home/servico/novo",
        actionText: "Cadastrar Taxa",
        type: "link"
      },
      {
        id: "first_comanda",
        title: "Primeira Venda em Comanda",
        description: "Abra uma mesa/comanda e teste o fechamento.",
        route: "/home/vendas/comanda",
        actionText: "Abrir Comandas",
        type: "link"
      },
      {
        id: "duxia_eval",
        title: "Análise com a DuxIA",
        description: "Avalie margens e sugestões de novos combos.",
        prompt: "Analise os produtos e serviços/combos que acabei de cadastrar: como estão minhas margens e que combos adicionais você sugere com base nas bebidas cadastradas?",
        actionText: "Consultar DuxIA",
        type: "duxia"
      }
    ]
  },
  "Cosméticos / Beleza": {
    id: "beauty",
    label: "Beleza & Barbearia",
    icon: "Face",
    badgeColor: "#06b6d4",
    badgeBg: "#ecfeff",
    tag: "Beleza & Estética",
    headline: "Serviços, profissionais e agenda",
    steps: [
      {
        id: "services",
        title: "Cadastrar Serviços",
        description: "Cadastre cortes, barba, manicure ou procedimentos.",
        route: "/home/servico/novo",
        actionText: "Novo Serviço",
        type: "link"
      },
      {
        id: "attendants",
        title: "Cadastrar Profissionais",
        description: "Cadastre os atendentes da equipe.",
        route: "/home/usuarios/novo",
        actionText: "Novo Profissional",
        type: "link"
      },
      {
        id: "resale_products",
        title: "Produtos de Revenda",
        description: "Cadastre cosméticos e pomadas do balcão.",
        route: "/home/produto/novo",
        actionText: "Cadastrar Produto",
        type: "link"
      },
      {
        id: "duxia_product_description",
        title: "Descrição com duxIA",
        description: "Gere textos valorizando benefícios dos cosméticos e cuidados.",
        route: "/home/produto/pesquisar",
        actionText: "Gerar Descrição",
        type: "duxia_feature"
      },
      {
        id: "duxia_customer_analysis",
        title: "Análise de Cliente duxIA",
        description: "Veja sugestões de procedimentos e contato na ficha do cliente.",
        route: "/home/cliente/pesquisar",
        actionText: "Analisar Cliente",
        type: "duxia_feature"
      },
      // {
      //   id: "agenda_setup",
      //   title: "Configurar Agenda",
      //   description: "Teste a marcação de horários na agenda.",
      //   route: "/home/agendamentos/agenda",
      //   actionText: "Acessar Agenda",
      //   type: "link"
      // },
      {
        id: "duxia_eval",
        title: "Análise com a DuxIA",
        description: "Descubra como alavancar o ticket médio com serviços e produtos.",
        prompt: "Analise a lista de serviços, profissionais e produtos de revenda que cadastrei: quais combinações de serviço + produto geram o melhor ticket médio para agendar?",
        actionText: "Consultar DuxIA",
        type: "duxia"
      }
    ]
  },
  "Mercado / Conveniência": {
    id: "market",
    label: "Mercado & Conveniência",
    icon: "ShoppingCart",
    badgeColor: "#10b981",
    badgeBg: "#ecfdf5",
    tag: "Alimentos & Varejo",
    headline: "Importação XML, caixas e vendas rápidas",
    steps: [
      {
        id: "categories",
        title: "Criar Categorias",
        description: "Organize setores (Bebidas, Mercearia, Limpeza).",
        route: "/home/categoria/nova",
        actionText: "Criar Categoria",
        type: "link"
      },
      {
        id: "xml_import",
        title: "Importação via XML (NF-e)",
        description: "Cadastre estoque importando notas de compras.",
        route: "/home/produto/pesquisar",
        actionText: "Importar XML",
        type: "link"
      },
      {
        id: "cashier_management",
        title: "Caixa de Gestão",
        description: "Cadastre o caixa cofre/retaguarda para sangrias.",
        route: "/home/caixas/novo",
        actionText: "Novo Caixa",
        type: "link"
      },
      {
        id: "quick_pos",
        title: "Venda Rápida no PDV",
        description: "Teste venda com leitor de código de barras.",
        route: "/home/vendas/nova",
        actionText: "Abrir PDV",
        type: "link"
      },
      {
        id: "duxia_eval",
        title: "Diagnóstico com a DuxIA",
        description: "Análise de giro e sortimento de estoque.",
        prompt: "Faça uma análise dos produtos e categorias que cadastrei no meu estoque: quais itens têm maior giro e como está a distribuição de preços?",
        actionText: "Consultar DuxIA",
        type: "duxia"
      }
    ]
  },
  "Serviços Gerais": {
    id: "services_auto",
    label: "Oficinas & Serviços",
    icon: "Build",
    badgeColor: "#f59e0b",
    badgeBg: "#fffbeb",
    tag: "Serviços & Manutenção",
    headline: "Mão de obra, peças, clientes e orçamentos",
    steps: [
      {
        id: "services_labor",
        title: "Cadastrar Serviços",
        description: "Cadastre mão de obra e manutenções.",
        route: "/home/servico/novo",
        actionText: "Novo Serviço",
        type: "link"
      },
      {
        id: "parts_stock",
        title: "Cadastrar Peças & Insumos",
        description: "Cadastre peças e materiais aplicados.",
        route: "/home/produto/novo",
        actionText: "Cadastrar Peças",
        type: "link"
      },
      {
        id: "first_client",
        title: "Cadastrar Cliente",
        description: "Registre dados e contato do cliente.",
        route: "/home/cliente/novo",
        actionText: "Novo Cliente",
        type: "link"
      },
      {
        id: "duxia_customer_analysis",
        title: "Análise de Cliente duxIA",
        description: "Consulte análise de relacionamento e histórico na ficha do cliente.",
        route: "/home/cliente/pesquisar",
        actionText: "Analisar Cliente",
        type: "duxia_feature"
      },
      {
        id: "budget_comanda",
        title: "Orçamento em Comandas",
        description: "Lance itens e imprima selecionando 'Orçamento'.",
        route: "/home/vendas/comanda",
        actionText: "Lançar Orçamento",
        type: "link"
      },
      {
        id: "duxia_eval",
        title: "Otimização com a DuxIA",
        description: "Dicas para fechar orçamentos mais lucrativos.",
        prompt: "Analise os serviços, peças e clientes que acabei de cadastrar: quais serviços têm melhor margem e como estruturar os próximos orçamentos em comanda?",
        actionText: "Consultar DuxIA",
        type: "duxia"
      }
    ]
  },
  "Outro": {
    id: "general",
    label: "Varejo & Geral",
    icon: "BusinessCenter",
    badgeColor: "#3b82f6",
    badgeBg: "#eff6ff",
    tag: "Comércio Geral",
    headline: "Configure categorias, produtos e catálogo",
    steps: [
      {
        id: "categories",
        title: "Criar Categorias",
        description: "Organize seus produtos por categorias.",
        route: "/home/categoria/nova",
        actionText: "Criar Categoria",
        type: "link"
      },
      {
        id: "products",
        title: "Cadastrar Produtos",
        description: "Cadastre produtos, preços e estoque.",
        route: "/home/produto/novo",
        actionText: "Novo Produto",
        type: "link"
      },
      {
        id: "duxia_product_description",
        title: "Descrição com duxIA",
        description: "Gere descrições persuasivas com copywriting profissional.",
        route: "/home/produto/pesquisar",
        actionText: "Gerar Descrição",
        type: "duxia_feature"
      },
      {
        id: "catalog",
        title: "Ativar Catálogo Virtual",
        description: "Divulgue sua vitrine para vender no WhatsApp.",
        route: "/home/gestao/catalogo",
        actionText: "Configurar Catálogo",
        type: "link",
        requireAddon: "catalog"
      },
      {
        id: "duxia_brand_palette",
        title: "Paleta de Cores duxIA",
        description: "Sugira uma paleta de cores moderna a partir da sua logo.",
        route: "/home/gestao/catalogo",
        actionText: "Sugerir Paleta",
        type: "duxia_feature",
        requireAddon: "catalog"
      },
      {
        id: "first_sale",
        title: "Primeira Venda no PDV",
        description: "Simule uma venda no ponto de venda.",
        route: "/home/vendas/nova",
        actionText: "Abrir PDV",
        type: "link"
      },
      {
        id: "duxia_eval",
        title: "Diagnóstico com a DuxIA",
        description: "Diagnóstico do catálogo e primeiros passos.",
        prompt: "Avalie meu cadastro inicial de categorias e produtos: dê um diagnóstico do meu catálogo e sugira os próximos passos para alavancar as vendas.",
        actionText: "Consultar DuxIA",
        type: "duxia"
      }
    ]
  }
};

export const STEP_GUIDES = {
  categories: {
    headline: "Como cadastrar categorias",
    whyItMatters: "As categorias agrupam seus itens, aceleram a busca no PDV e organizam sua vitrine online.",
    steps: [
      "Acesse Cadastros > Categorias e clique em 'Nova Categoria'.",
      "Digite o nome da categoria (ex: Camisetas, Bebidas, Sobremesas) e selecione o tipo.",
      "Clique em 'Salvar' para que ela fique disponível no cadastro de produtos."
    ],
    tip: "Crie de 3 a 6 categorias principais para manter o menu do PDV ágil e intuitivo."
  },
  products: {
    headline: "Como cadastrar produtos e estoque",
    whyItMatters: "Produtos com preço de venda, custo e estoque inicial permitem vendas rápidas e controle financeiro.",
    steps: [
      "Acesse Cadastros > Produtos e clique em 'Novo Produto'.",
      "Informe o nome, selecione a categoria e digite o preço de venda.",
      "Preencha o estoque inicial e o preço de custo para acompanhar seus lucros."
    ],
    tip: "Use o botão da duxIA no cadastro do produto para gerar descrições profissionais automaticamente."
  },
  stock_drinks: {
    headline: "Como cadastrar bebidas e estoque",
    whyItMatters: "Mantenha o controle de latas, destilados, garrafas e gelo com avisos de reposição.",
    steps: [
      "Acesse Cadastros > Produtos e clique em 'Novo Produto'.",
      "Cadastre a bebida informando a unidade (lata, garrafa, fardo) e preço de venda.",
      "Defina o estoque mínimo para ser alertado quando o produto estiver acabando."
    ],
    tip: "Cadastre com o código de barras para usar o leitor e acelerar o atendimento no caixa."
  },
  resale_products: {
    headline: "Como cadastrar produtos de revenda",
    whyItMatters: "Cosméticos, pomadas e produtos expostos no balcão aumentam expressivamente o faturamento.",
    steps: [
      "Acesse Cadastros > Produtos e clique em 'Novo Produto'.",
      "Informe o nome do cosmético ou item de revenda e o valor de balcão.",
      "Cadastre a quantidade recebida em estoque."
    ],
    tip: "Ofereça produtos de revenda logo após concluir um atendimento ou serviço ao cliente."
  },
  parts_stock: {
    headline: "Como cadastrar peças e materiais aplicados",
    whyItMatters: "Controla o estoque de peças e materiais usados em consertos, manutenções e orçamentos.",
    steps: [
      "Acesse Cadastros > Produtos e clique em 'Novo Produto'.",
      "Preencha o código/nome da peça e o valor de custo e venda.",
      "Informe a quantidade disponível na oficina/estoque."
    ],
    tip: "Você poderá lançar essas peças diretamente na comanda ou ordem de serviço."
  },
  xml_import: {
    headline: "Como importar estoque via XML (NF-e)",
    whyItMatters: "Importa dezenas de itens com códigos de barras, custos e tributos direto da nota do fornecedor.",
    steps: [
      "Acesse Produtos > Pesquisar e clique no botão 'Importar XML'.",
      "Selecione o arquivo .xml da NF-e fornecida pela distribuidora.",
      "Revise os produtos e confirme a entrada automática no estoque."
    ],
    tip: "O sistema vincula os produtos já cadastrados e cria automaticamente os que forem novos."
  },
  services: {
    headline: "Como cadastrar serviços",
    whyItMatters: "Serviços representam procedimentos, cortes e atendimentos realizados pela sua equipe.",
    steps: [
      "Acesse Cadastros > Serviços e clique em 'Novo Serviço'.",
      "Informe o nome do procedimento (ex: Corte Cabelo, Manicure) e o preço.",
      "Selecione a categoria correspondente e salve."
    ],
    tip: "Serviços cadastrados podem ser vinculados à agenda e aos profissionais responsáveis."
  },
  services_combos: {
    headline: "Como criar combos com baixa de insumos",
    whyItMatters: "Permite vender copões e combos (ex: 1 Garrafa + 4 Energéticos) dando baixa correta em cada item.",
    steps: [
      "Acesse Cadastros > Serviços e clique em 'Novo Serviço'.",
      "Preencha o nome do combo (ex: 'Combo Whisky + 4 Energéticos') e o preço total.",
      "Na seção de insumos, adicione as bebidas e quantidades que compõem o kit."
    ],
    tip: "Ao vender o combo, o estoque de cada bebida individual é baixado automaticamente."
  },
  services_labor: {
    headline: "Como cadastrar serviços de mão de obra",
    whyItMatters: "Padronize os preços de mão de obra e manutenções aplicadas em ordens de serviço.",
    steps: [
      "Acesse Cadastros > Serviços e clique em 'Novo Serviço'.",
      "Informe o tipo de serviço/reparo e o valor base de mão de obra.",
      "Vincule à categoria de serviços e salve."
    ],
    tip: "Lance a mão de obra junto com as peças utilizadas nas comandas de orçamento."
  },
  attendants: {
    headline: "Como cadastrar atendentes e profissionais",
    whyItMatters: "Permite acompanhar atendimentos por colaborador e controlar permissões de acesso.",
    steps: [
      "Acesse Gestão > Usuários e clique em 'Novo Usuário'.",
      "Informe o nome, e-mail e perfil de acesso do colaborador.",
      "Defina a senha inicial para que ele possa acessar o sistema."
    ],
    tip: "Você pode restringir o que cada usuário pode ver, como relatórios financeiros e custos."
  },
  waiter_user: {
    headline: "Como cadastrar garçons e atendentes",
    whyItMatters: "Garçons com login próprio podem abrir mesas e lançar pedidos direto pelo celular ou tablet.",
    steps: [
      "Acesse Gestão > Usuários e clique em 'Novo Usuário'.",
      "Cadastre o nome do garçom e selecione o perfil de Atendimento.",
      "Defina a senha de login rápido para uso no salão."
    ],
    tip: "Lançamentos via garçom aparecem em tempo real no caixa e na cozinha/bar."
  },
  first_client: {
    headline: "Como cadastrar clientes",
    whyItMatters: "Registra histórico de compras, hábitos de consumo e viabiliza relacionamento por WhatsApp.",
    steps: [
      "Acesse Cadastros > Clientes e clique em 'Novo Cliente'.",
      "Informe o nome completo e o número de WhatsApp com DDD.",
      "Salve para vincular vendas, agendamentos e comandas a esse cliente."
    ],
    tip: "Use a aba da duxIA no cliente para receber diagnósticos de compras e mensagens personalizadas."
  },
  cashier_management: {
    headline: "Como gerenciar múltiplos caixas",
    whyItMatters: "Separa o caixa de frente (atendimento PDV) do caixa de retaguarda/cofre para segurança.",
    steps: [
      "Acesse Financeiro > Caixas e clique em 'Novo Caixa'.",
      "Defina o nome do caixa (ex: 'Caixa 01 - Frente', 'Cofre/Retaguarda').",
      "Realize aberturas diárias com fundo de troco e sangrias sempre que necessário."
    ],
    tip: "Mantenha no PDV apenas o dinheiro necessário para troco, transferindo o restante via sangria."
  },
  first_sale: {
    headline: "Como realizar sua primeira venda no PDV",
    whyItMatters: "O PDV é rápido, intuitivo e calcula troco, descontos e formas de pagamento em instantes.",
    steps: [
      "Acesse Vendas > Nova Venda (PDV).",
      "Digite o nome do produto ou use o leitor de código de barras.",
      "Selecione a forma de pagamento (Dinheiro, PIX, Cartão) e clique em Concluir Venda."
    ],
    tip: "Pressione Shift + Espaço no teclado para abrir a pesquisa rápida de produtos."
  },
  quick_pos: {
    headline: "Como usar a venda rápida com leitor de código de barras",
    whyItMatters: "Ideal para filas rápidas: basta bipar os produtos sequencialmente e fechar o pagamento.",
    steps: [
      "Acesse Vendas > Nova Venda (PDV).",
      "Com o leitor conectado, bipe os produtos do cliente.",
      "Pressione Enter ou clique em Finalizar para selecionar o pagamento."
    ],
    tip: "O sistema aceita múltiplos pagamentos divididos na mesma venda (ex: metade PIX, metade Cartão)."
  },
  first_comanda: {
    headline: "Como usar comandas e mesas",
    whyItMatters: "Gerencia contas abertas para mesas e clientes que pagam apenas no final do consumo.",
    steps: [
      "Acesse Vendas > Comandas.",
      "Abra uma nova comanda digitando o número da mesa/cartão.",
      "Lance produtos e bebidas conforme o cliente for pedindo e feche a conta no caixa."
    ],
    tip: "Você pode imprimir o extrato parcial da mesa antes do pagamento definitivo."
  },
  budget_comanda: {
    headline: "Como gerar orçamentos em comanda",
    whyItMatters: "Lance peças e serviços para apresentar uma estimativa de valor para aprovação do cliente.",
    steps: [
      "Acesse Vendas > Comandas e abra uma nova comanda.",
      "Adicione os serviços de mão de obra e peças necessárias.",
      "Selecione a opção 'Orçamento' para imprimir a proposta para o cliente."
    ],
    tip: "Após a aprovação do cliente, basta finalizar a comanda normalmente no caixa."
  },
  catalog: {
    headline: "Como ativar e divulgar o Catálogo Virtual",
    whyItMatters: "Sua loja virtual própria para receber pedidos organizados diretamente no WhatsApp.",
    steps: [
      "Acesse Gestão > Catálogo Virtual.",
      "Defina o endereço/slug da sua vitrine e personalize o banner e logotipo.",
      "Marque os produtos que devem ser exibidos e ative o catálogo."
    ],
    tip: "Coloque o link do catálogo na bio do seu Instagram para receber pedidos todos os dias."
  },
  agenda_setup: {
    headline: "Como organizar atendimentos na Agenda",
    whyItMatters: "Elimine furos e atrasos organizando os horários de cada profissional em um painel visual.",
    steps: [
      "Acesse Agendamentos > Agenda.",
      "Clique no horário desejado na coluna do profissional.",
      "Selecione o cliente e o serviço a ser realizado e confirme."
    ],
    tip: "A agenda calcula o tempo estimado com base na duração cadastrada em cada serviço."
  },
  delivery_settings: {
    headline: "Como cadastrar taxas de entrega e repasse",
    whyItMatters: "Permite cobrar o frete do cliente e acompanhar os repasses devidos aos motoboys.",
    steps: [
      "Acesse Cadastros > Serviços e clique em 'Novo Serviço'.",
      "Cadastre a taxa de entrega (ex: 'Taxa Entrega Centro - R$ 8,00').",
      "Selecione a categoria 'Repasses' e ative a opção de custo/repasse."
    ],
    tip: "Cadastre uma taxa para cada bairro para manter os custos e repasses 100% transparentes."
  },
  duxia_product_description: {
    headline: "Como gerar descrições com a DuxIA",
    whyItMatters: "A inteligência artificial cria textos atraentes e persuasivos que aumentam suas vendas.",
    steps: [
      "Acesse o cadastro de qualquer produto.",
      "Clique no botão roxo 'Gerar Descrição' com o ícone da duxIA.",
      "A IA elaborará uma descrição profissional pronta para seu catálogo e redes sociais."
    ],
    tip: "Você pode ajustar o texto gerado antes de salvar para dar o seu toque pessoal."
  },
  duxia_brand_palette: {
    headline: "Como gerar a identidade visual com a DuxIA",
    whyItMatters: "A duxIA extrai as cores ideais da sua marca para deixar sua vitrine virtual com visual premium.",
    steps: [
      "Acesse Gestão > Catálogo > aba 'Identidade Visual'.",
      "Envie a imagem do seu logotipo ou banner.",
      "Clique em 'Sugerir Paleta com duxIA' para aplicar automaticamente o design do tema."
    ],
    tip: "Um visual harmônico aumenta a confiança do cliente e o valor percebido dos produtos."
  },
  duxia_customer_analysis: {
    headline: "Como fazer análise de clientes com a DuxIA",
    whyItMatters: "Entenda o perfil de cada cliente e receba mensagens prontas para enviar no WhatsApp.",
    steps: [
      "Acesse Cadastros > Clientes > Pesquisar e abra um cliente com histórico.",
      "Clique na aba 'Análise duxIA'.",
      "Veja o diagnóstico inteligente e clique para copiar a mensagem sugerida para o WhatsApp."
    ],
    tip: "Utilize essas sugestões para reengajar clientes inativos com ofertas certeiras."
  },
  duxia_eval: {
    headline: "Como consultar a DuxIA para diagnóstico do negócio",
    whyItMatters: "Receba orientações estratégicas de uma especialista em crescimento comercial.",
    steps: [
      "Clique no botão 'Consultar DuxIA' no checklist ou abra o chat flutuante.",
      "Envie a mensagem com a pergunta analítica já preparada para o seu segmento.",
      "Acompanhe o parecer detalhado e aplique as recomendações no seu negócio."
    ],
    tip: "Peça conselhos sobre precificação, combos mais vendidos e estratégias de fidelização."
  }
};

export const normalizeSegment = (rawSegment) => {
  if (!rawSegment) return "Outro";
  const s = rawSegment.trim();
  if (SEGMENTS_DATA[s]) return s;

  const lower = s.toLowerCase();
  if (lower.includes("roupa") || lower.includes("moda") || lower.includes("vestu")) return "Roupas / Moda";
  if (lower.includes("restaurante") || lower.includes("bar") || lower.includes("adega") || lower.includes("bebida") || lower.includes("comida") || lower.includes("alimenta")) return "Restaurante / Alimentação";
  if (lower.includes("beleza") || lower.includes("salao") || lower.includes("barbearia") || lower.includes("estetica") || lower.includes("cosmet")) return "Cosméticos / Beleza";
  if (lower.includes("mercado") || lower.includes("mercearia") || lower.includes("conveniencia") || lower.includes("hortifrut")) return "Mercado / Conveniência";
  if (lower.includes("servico") || lower.includes("oficina") || lower.includes("mecanic") || lower.includes("manutencao") || lower.includes("auto")) return "Serviços Gerais";
  return "Outro";
};
